<template>
  <div class="menu" :class="{ showMenu: drawer }">
    <div class="menu__overlay" @click="handleToggleMenu"></div>
    <div class="menu__drawer">
      <div class="menu__drawer--close">
        <p @click="handleToggleMenu">
          <img src="~ThemePath/images/icon/icon_close.svg" alt="" />
          <span>{{ getTranslatedText("close") }}</span>
        </p>
      </div>
      <div class="menu__drawer--title">
        <h3>{{ getTranslatedText("lottotech merchant pos") }}</h3>
      </div>
      <ul class="menu__drawer--info">
        <li>
          {{ getTranslatedText("retail number:") }}
          <span>{{ userInfo ? userInfo?.retail_number : this.$store.state.userInfo?.retail_number }}</span>
        </li>
        <li>
          {{ getTranslatedText("teller id:") }}
          <span>{{ userInfo ? userInfo?.teller_id : this.$store.state.userInfo?.teller_id }}</span>
        </li>
        <li>
          {{ getTranslatedText("current date time:") }}
          <span>{{ $helpers.formatDateTime(currentDate) }}</span>
        </li>
      </ul>
      <ul class="menu__drawer--item">
        <li @click="handleClickMenu('/')">{{ getTranslatedText("home") }}</li>
        <li @click="handleClickMenu('/ticket-validation')">
          {{ getTranslatedText("ticket validation") }}
        </li>
        <li @click="handleClickMenu('/history')">
          {{ getTranslatedText("view transaction") }}
        </li>
        <li @click="handleClickMenu('/reports')">
          {{ getTranslatedText("reports") }}
        </li>
        <li @click="handleClickMenu('/results')">
          {{ getTranslatedText("results") }}
        </li>
        <li @click="handleClickMenu('/settings')">
          {{ getTranslatedText("settings") }}
        </li>
      </ul>
      <div class="menu__drawer--button">
        <ButtonCommon :isNoHover="true" text="logout" @action-button="handleLogout" type="" />
      </div>
    </div>
  </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins";
import ButtonCommon from "@/components/common/button/index.vue";
import AuthService from "@/services/auth.service";
import { getUserInfo } from '@/services/axios';
import getSrvTime from "@/mixins/getSrvTime/getSrvTime-mixins";
import EventBus from '@/utils/EventBus';
export default {
  components: { ButtonCommon },
  mixins: [languageMixins, getSrvTime],
  props: {},
  data() {
    return {
      drawer: false,
      currentDate: this.srvTime(),
      userInfo: getUserInfo() ? JSON.parse(getUserInfo()) : getUserInfo()
    };
  },
  methods: {
    async handleLogout() {
      try {
        await AuthService.logout();
        this.$store.dispatch("clearAllBetslip");
        this.$store.dispatch("clearAllCheckout");
        this.$router.push("/login");
      } catch (error) {
        console.log(error);
      }
    },
    handleToggleMenu() {
      this.drawer = !this.drawer;
    },
    handleClickMenu(url) {
      this.$router.push(url);
      parent.postMessage({ command: 'is-show-cammera', param: false }, '*')
      EventBus.$emit('on-hide-camere-scan')
      this.drawer = !this.drawer;
      if (this.$route.name === 'Home') {
        EventBus.$emit('reset-steps')
      }
    },
  },
  mounted() {
    setInterval(() => {
      // this.currentDate = new Date();
      this.currentDate.setSeconds(this.currentDate.getSeconds() + 1);
      this.currentDate = new Date(this.currentDate);
    }, 1000);
  },
};
</script>
<style lang="scss">
@import "~ThemePath/scss/menu/_index.scss";
</style>
